import React from "react";
import {
    Header,
    Tab,
} from "semantic-ui-react";
import styled from "styled-components";
import { MenuSettingTab } from "./list";
import { PermissionsScreen } from "screens/permissions";
import { MenuDefaultsTab } from "./MenuDefaultsTab";
import { useAuth } from "context";

const Container = styled.div`
  padding: 20px;
`;

export const MenuSettingScreen = () => {
    const { user } = useAuth();
    const isSuperAdmin = user?.IsSuperAdmin || user?.Capabilities?.CanManageMenuDefaults;

    const panes = [
        {
            menuItem: 'Menu',
            render: () => (
                <MenuSettingTab />
            ),
        },
        {
            menuItem: 'permissions',
            render: () => (
                <PermissionsScreen />
            ),
        },
        ...(isSuperAdmin
            ? [
                {
                    menuItem: 'Menu Defaults',
                    render: () => (
                        <MenuDefaultsTab />
                    ),
                },
            ]
            : []),
    ]

    return (
        <Container>
            <Header as="h3">Menu Configuration</Header>

            <Tab menu={{ secondary: true, pointing: true }} panes={panes} />

        </Container>
    );
};